export default __webpack_public_path__ + "static/media/email.e1e1ca6d.svg";